import styled from 'styled-components';

export const Row = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(12, 1fr);
`;
